import config from '../../util/config';
import { graphRequest } from '../../util/graphRequest';

export async function orgsRequest(
  query: string,
  variables: {},
): Promise<Response> {
  return graphRequest(query, variables, config.snap.graphUri);
}
